import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link
import { UtensilsCrossed } from 'lucide-react';
import Spice from '../../assets/spice grains agro new.webp';

const SpicesHome = ({ company }) => {
  const getHeroIcon = (companyId, size = 120) => {
    const icons = {
      spices: (
        <img
          src={Spice}
          alt="Utensils Crossed"
          className={`w-[${size / 8}] h-[${size / 8}] max-w-[${size}px] max-h-[${size}px] drop-shadow-2xl object-contain`}
        />
      ),
     
    };
    return icons[companyId] || (
      <UtensilsCrossed size={size} className="text-green-700 drop-shadow-lg" />
    );
  };

  return (
    <div className="animate-in fade-in duration-700">
      <section className="bg-gradient-to-br from-green-50 via-emerald-50 to-green-100 py-24 px-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-green-200/10 via-transparent to-emerald-200/10"></div>
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div className="space-y-8">
            <h2 className="text-6xl font-black leading-tight mb-6 bg-gradient-to-r from-slate-800 via-green-900 to-emerald-800 bg-clip-text text-transparent drop-shadow-2xl">
              Pure{' '}
              <span className="text-transparent bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text drop-shadow-2xl">
                Heritage
              </span>
              , Global Reach.
            </h2>
            <p className="text-xl text-slate-700/90 mb-10 leading-relaxed max-w-lg bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-2xl border border-green-100/50">
              {company.description} Ensuring quality from the source to your doorstep.
            </p>

            {/* ✅ Updated Links */}
            <div className="flex flex-col sm:flex-row gap-6">
              <Link
                to="/services"
                className="px-12 py-7 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-3xl font-black text-xl hover:from-emerald-600 hover:to-green-700 hover:shadow-2xl hover:shadow-green-500/40 transition-all duration-500 shadow-xl hover:scale-105 group flex justify-center"
              >
                <span className="block group-hover:-translate-x-2 transition-transform">
                  Explore Products
                </span>
              </Link>

              <Link
                to="/contact"
                className="px-12 py-7 border-4 border-green-500 text-green-700 rounded-3xl font-black text-xl hover:bg-white hover:shadow-2xl hover:shadow-green-200/50 hover:scale-105 transition-all duration-500 bg-white/70 backdrop-blur-sm flex items-center justify-center group"
              >
                <span className="group-hover:-translate-x-1 transition-transform">
                  Contact Sales
                </span>
              </Link>
            </div>
          </div>

          <div className="hidden md:flex justify-center relative">
            <div className="w-96 h-96 bg-white/90 backdrop-blur-2xl rounded-[3rem] shadow-2xl flex items-center justify-center border-8 border-green-100 relative group hover:shadow-green-300/40 transition-all duration-1000 hover:scale-110 hover:rotate-1">
              <div className="absolute inset-0 bg-gradient-to-br from-green-200/30 to-emerald-200/30 rounded-[3rem] opacity-0 group-hover:opacity-100 transition-all duration-700 blur-xl"></div>
              <div className="absolute inset-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-[2.8rem] shadow-inner"></div>
              {getHeroIcon(company.id, 140)}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SpicesHome;
